
// export const API_BASE_URL = "http://127.0.0.1:8080"

// export const API_BASE_URL = "https://fashionapp99.uc.r.appspot.com"; 
export const API_BASE_URL = "https://yards-backend-prod.uc.r.appspot.com";